import { Menu } from '@mantine/core';
import { IconBook } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';
import { useNavigate } from 'react-router-dom';

const ThesaurusMenuItem = () => {
  const { t } = useTranslate();
  const navigate = useNavigate();

  return (
    <Menu.Item leftSection={<IconBook stroke={1.5} />} onClick={() => navigate('/thesaurus')}>
      {t('nav.thesaurus')}
    </Menu.Item>
  );
};

export default ThesaurusMenuItem;
